<ng-container>
  <!-- Loader -->
  @if (!config?.loaded) {
    <div class="loader-container">
      @if (config?.askData) {
        <div class="analyzing-text">Ask a question to talk to your data.</div>
      }
      @if (!config?.askData) {
        <div class="spinner"></div>
        <div class="analyzing-text">Analyzing data...</div>
      }
    </div>
  }

  <!-- No Data Message -->
  @if (config?.loaded && config?.noData) {
    <div class="no-data-container">
      <div class="no-data-message">Not available</div>
    </div>
  }

  <!-- Content -->
  @if (config?.loaded && !config?.noData) {
    <div class="output-container">
      @switch (config?.outputType) {
        <!-- Chart View -->
        @case ('chart') {
          <div class="view-controls">
            <div class="view-toggle">
              <label class="toggle-switch">
                <input type="checkbox" [(ngModel)]="config.defaultViewMode" (change)="setDefaultViewMode(config.defaultViewMode ? 'table' : 'chart')">
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">Table View</span>
            </div>
          </div>
          @if (summaryPoints.length) {
            <div class="summary-section">
              <h2>Key Insights <span class="beta-label">AI generated document(Beta)</span></h2>
              <ul class="insights-list">
                @for (point of summaryPoints; track point) {
                  <li>
                    <i class="fas fa-lightbulb text-warning"></i>
                    <span>{{ point }}</span>
                  </li>
                }
              </ul>
            </div>
          }
          @if (analyticsData?.charts?.length > 0) {
            <div class="chart-grid">
              @for (chart of analyticsData.charts; track chart) {
                <div class="chart-card">
                  <div class="chart-header">
                    <h3>{{chart.title}}</h3>
                  </div>
                  <div class="chart-content">
                    <!-- Chart View -->
                    @if (!config.defaultViewMode) {
                      <div class="chart-container">
                        <canvas [id]="getSafeChartId(chart.title)"></canvas>
                      </div>
                    }
                    <!-- Table View -->
                    @if (config.defaultViewMode) {
                      <div class="table-container">
                        <table class="data-table">
                          <thead>
                            <tr>
                              @for (col of chart['cols']; track col) {
                                <th>{{col}}</th>
                              }
                            </tr>
                          </thead>
                          <tbody>
                            @for (row of chart['chData']; track row) {
                              <tr>
                                @for (col of chart['cols']; track col) {
                                  <td>{{row[col]}}</td>
                                }
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                    @if (chart.recommendation) {
                      <div class="recommendation">
                        <i class="fa fa-lightbulb-o text-info"></i>
                        {{ chart.recommendation }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <!-- New Data Tables Section -->
          @if (analyticsData?.tables?.length > 0) {
            <div class="data-tables-section">
              <h2 class="section-title">Detailed Analysis</h2>
              <div class="data-tables-grid">
                @for (table of analyticsData.tables; track table) {
                  <div class="data-table-card">
                    <div class="data-table-header">
                      <h3>{{table.title}}</h3>
                    </div>
                    <div class="data-table-content">
                      <div class="data-table-wrapper">
                        <div class="table-responsive">
                          <table class="data-table">
                            <thead>
                              <tr>
                                @for (column of table.columns; track column) {
                                  <th>{{column}}</th>
                                }
                              </tr>
                            </thead>
                            <tbody>
                              @for (row of table.rows; track row) {
                                <tr>
                                  @for (cell of row; track cell) {
                                    <td>{{cell}}</td>
                                  }
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
        <!-- HTML View -->
        @case ('component') {
          <div class="summary-section-html">
            <ng-container *ngTemplateOutlet="infoBlock;"></ng-container>
            <ng-template #customComponent>
            </ng-template>
          </div>
        }
        @case ('html') {
          <div class="summary-section-html">
            <ng-container *ngTemplateOutlet="infoBlock;"></ng-container>
            <div [innerHTML]="renderedSummary"></div>
          </div>
        }
        @case ('ai_report') {
          <div class="summary-section-html">
            <ng-container *ngTemplateOutlet="infoBlock;"></ng-container>
            <kx-ai-report-viewer [data]="config.summary" [schema]="config.schema"></kx-ai-report-viewer>
          </div>
        }
        @case ('ask_your_data') {
          <app-kx-ai-data-analysis [config]="config"></app-kx-ai-data-analysis>
        }
      }
    </div>
  }
</ng-container>

<ng-template #infoBlock >
  <span class="beta-label float-right">AI generated Report(Beta)</span>
</ng-template>